module.exports = __webpack_public_path__ + "static/media/kr-ellipse.2c5f8348.png";